import { TokenStorageService } from './../auth/helpers/token-storage.service';
import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs'
@Injectable()
export class MessagingService {
    currentMessage = new BehaviorSubject(null);
    constructor(private angularFireMessaging: AngularFireMessaging,  private toastr: ToastrService, private tks: TokenStorageService) {
        this.angularFireMessaging.messages.subscribe(
            (_messaging: AngularFireMessaging) => {
                _messaging.onMessage = _messaging.onMessage.bind(_messaging);
                _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
            }
        )
    }
    requestPermission() {
        this.angularFireMessaging.requestToken.subscribe(
            (token) => {
                if (token !== null){
                    this.tks.saveTokenFB(token);
                }
            },
            (err) => {
                console.error('Unable to get permission to notify.', err);
            }
        );
    }
    receiveMessage() {
        this.angularFireMessaging.messages.subscribe(
            (payload) => {
                this.toastr.info(payload['notification'].body, payload['notification'].title, {
                    toastClass: "toast ngx-toastr",
                    closeButton: true,
                  });
                this.currentMessage.next(payload);
            })
    }
}